import { useTranslation } from 'react-i18next'
import { Globe } from 'lucide-react'
import { setLocale, getLocale, SUPPORTED_LOCALES, type Locale } from '../../i18n'
import { api } from '../../lib/api'
import { useAuthStore } from '../../stores/auth.store'

interface Props {
  collapsed?: boolean
}

export function LanguageSwitcher({ collapsed = false }: Props): JSX.Element {
  const { t } = useTranslation('common')
  const current = getLocale()
  const isAuthed = useAuthStore((s) => !!s.user)

  const next: Locale = current === 'tr' ? 'en' : 'tr'
  const nextLabel = t(`language.${next}`)

  const handleClick = () => {
    setLocale(next)
    // Logged-in kullanıcılar için backend'de tercih sakla — sessiz başarısız ol
    if (isAuthed) {
      void api.patch('/auth/me/language', { language: next }).catch(() => {})
    }
  }

  if (collapsed) {
    return (
      <button
        onClick={handleClick}
        title={`${t('language.switchTo')} ${nextLabel}`}
        className="w-full flex items-center justify-center gap-3 rounded-lg px-0 py-2.5 text-sm text-sidebar-foreground hover:bg-accent/50 hover:text-foreground transition-all duration-150"
      >
        <Globe size={22} className="flex-shrink-0 text-sky-400 transition-all duration-150" />
      </button>
    )
  }

  return (
    <button
      onClick={handleClick}
      title={`${t('language.switchTo')} ${nextLabel}`}
      className="w-full flex items-center gap-3 rounded-lg px-3 py-2 text-sm text-sidebar-foreground hover:bg-accent/50 hover:text-foreground transition-all duration-150"
    >
      <Globe size={18} className="flex-shrink-0 text-sky-400 transition-all duration-150" />
      <span className="flex-1 text-left">{t(`language.${current}`)}</span>
      <span className="text-xs text-muted-foreground uppercase">{current}</span>
    </button>
  )
}

export const supportedLocales = SUPPORTED_LOCALES
